import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { Trans } from '@wix/wix-i18n-config';
import { Box, TextButton } from '@wix/design-system';
import { WIX_APP_MARKET_TERMS_AND_CONDITIONS } from '../../../consts';
import { getCompanyName, getCompanyPrivacyPolicy } from '../../../selectors/companyInfo';
import { getAppName } from '../../../selectors/appRuntimeReader';
import { getAppNameAppMarket, getAppTermsOfUseUrl } from '../../../selectors/marketListing';
import { useLibraryTranslations } from '../../../context/TranslationsContext';
import { useInstallerContext } from '../../../context/InstallerContext';
export const useTermsAndConditionsText = _ref => {
  let {
    darkCtas
  } = _ref;
  const transProps = useLibraryTranslations();
  const {
    t
  } = transProps;
  const {
    preInstallationData: {
      app,
      companyInfo,
      marketListing,
      isAppAlreadyInstalled
    },
    shareUrlId
  } = useInstallerContext();
  const termsAndConditionsUrl = getAppTermsOfUseUrl(marketListing);
  const privacyPolicyUrl = getCompanyPrivacyPolicy(companyInfo);
  const isAppAlreadyInstalledString = String(isAppAlreadyInstalled);
  const companyName = getCompanyName(companyInfo);
  const textButtonSkin = darkCtas ? 'dark' : 'standard';
  const appName = getAppNameAppMarket(marketListing) || getAppName(app);
  const WixTermsAndConditions = /*#__PURE__*/React.createElement(TextButton, {
    size: "small",
    underline: "always",
    skin: textButtonSkin,
    dataHook: "wix-terms-and-conditions-button",
    onClick: () => window.open(WIX_APP_MARKET_TERMS_AND_CONDITIONS)
  });
  const TpaTermsAndConditions = /*#__PURE__*/React.createElement(TextButton, {
    size: "small",
    underline: "always",
    skin: textButtonSkin,
    dataHook: "tpa-terms-and-conditions-button",
    onClick: () => window.open(termsAndConditionsUrl)
  });
  const TpaPrivacyPolicy = privacyPolicyUrl ? /*#__PURE__*/React.createElement(TextButton, {
    size: "small",
    underline: "always",
    skin: textButtonSkin,
    dataHook: "tpa-privacy-policy-button",
    onClick: () => window.open(privacyPolicyUrl)
  }) : /*#__PURE__*/React.createElement("span", null);
  const commonProps = {
    ...transProps,
    values: {
      appName: privacyPolicyUrl && !termsAndConditionsUrl ? companyName : appName,
      isAppAlreadyInstalled: isAppAlreadyInstalledString
    }
  };
  if (shareUrlId) {
    return /*#__PURE__*/React.createElement(Box, {
      dataHook: "install-via-link-terms-and-conditions"
    }, t('user-consent.terms-and-conditions.install-via-link', {
      isAppAlreadyInstalled: isAppAlreadyInstalledString
    }));
  }
  if (termsAndConditionsUrl) {
    return /*#__PURE__*/React.createElement(Trans, _extends({}, commonProps, {
      i18nKey: "user-consent.terms-and-conditions.custom-terms-and-privacy"
    }), WixTermsAndConditions, TpaTermsAndConditions, TpaPrivacyPolicy);
  }
  return /*#__PURE__*/React.createElement(Trans, _extends({}, commonProps, {
    dataHook: "default-terms-and-conditions",
    i18nKey: "user-consent.terms-and-conditions.default"
  }), WixTermsAndConditions, TpaPrivacyPolicy);
};
//# sourceMappingURL=useTermsAndConditionsText.js.map